module.exports = "<span class=\"array_value\">{{arrayValue}}</span>";